/**
 * package: com.inq.ui
 * class: IFrame
 * @extends com.inq.ui.Container
 * @constructor
 */
com.inq.ui.IFrame = function(_id) {
	com.inq.ui.Container.call(this,_id);
	this.initStyle("id",_id);
	this._div.innerHTML = "<IFRAME width=\"100%\" height=\"100%\" scrolling=\"NO\" frameborder=\"0\"></IFRAME>";
	this._iframe = this._div.getElementsByTagName("IFRAME")[0];
	this.setScrolling("no");
};
$hxClasses.extend(com.inq.ui.Container, com.inq.ui.IFrame, "com.inq.ui.IFrame");

/**
 * setScrolling -
 * setter for scrolling attribute
 *
 * param val - value of the scrolling attribute
 *
 * $type TFun([{ name => val, t => TDynamic(null), opt => false }],TDynamic(null))
 * override private function setScrolling(val:Dynamic):Dynamic
 * @override
 * @private
 * @this com.inq.ui.IFrame
 * @param {null}  val
 * @return {null}
 */
com.inq.ui.IFrame.prototype.setScrolling = function(val) {
	if(this._div != null) {
		this.scrolling = val;
		this._iframe.scrolling = val;
		this._iframe.setAttribute("scrolling",val);
	}
};


/**
 * setSrc
 *
 * $type TFun([{ name => val, t => TDynamic(null), opt => false }],TDynamic(null))
 * override private function setSrc(val:Dynamic):Dynamic
 * @override
 * @private
 * @this com.inq.ui.IFrame
 * @param {null}  val
 * @return {null}
 */
com.inq.ui.IFrame.prototype.setSrc = function(val) {
	if(this._div != null) {
		this.src = val;
		if(this.src == null || this.src == "") return;
		this._iframe.src = this.evaluateString(this.src);
	}
};


/**
 * setHandCursor
 *
 * $type TFun([{ name => val, t => TDynamic(null), opt => false }],TDynamic(null))
 * private function setHandCursor(val:Dynamic):Dynamic
 * @private
 * @this com.inq.ui.IFrame
 * @param {string}  val
 */
com.inq.ui.IFrame.prototype.setHandCursor = function(val) {
	/** @type {string} */
	var value = val;
	switch(value.toLowerCase()) {
		case "true":
			this._useHandCursor = true;
			break;
		case "false":
			this._useHandCursor = false;
			break;
		default:
			this._useHandCursor = false;
	}
	this.useHandCursor = this._useHandCursor?"true":"false";
};


/**
 * resize
 *
 * $type TFun([],TEnum(Void,[]))
 * public override function resize()
 * @override
 * @public
 * @this com.inq.ui.IFrame
 * @return {void}
 */
com.inq.ui.IFrame.prototype.resize = function() {
	this.applyStyle();
};


/**
 * setLabel
 *
 * $type TFun([{ name => val, t => TDynamic(null), opt => false }],TDynamic(null))
 * private function setLabel(val:Dynamic):Dynamic
 * @private
 * @this com.inq.ui.IFrame
 * @param {null}  val
 * @return {null}
 */
com.inq.ui.IFrame.prototype.setLabel = function(val) {
	this.label = val;
};


/**
 * buildStyle
 *
 * $type TFun([],TEnum(Void,[]))
 * override private function buildStyle():Void
 * @override
 * @private
 * @this com.inq.ui.IFrame
 * @return {void}
 */
com.inq.ui.IFrame.prototype.buildStyle = function() {
	com.inq.ui.Container.prototype.buildStyle.call(this);
	/* if (null != src) */
	/* 	_style += 'background: transparent url(' + src + ') no-repeat scroll;'; */
	if(this._useHandCursor) this._style += "cursor: pointer;";

	var accesskey = this.getStyle("accesskey");
	if(null != accesskey) {
		this._div.setAttribute("accesskey", accesskey)
	}
	var tabindex = this.getStyle("tabindex");
	if(null != tabindex) {
		this._div.setAttribute("tabindex", tabindex)
	}
};

/** @private @type {null} */
com.inq.ui.IFrame.prototype._iframe = null;
/** @private @type {null} */
com.inq.ui.IFrame.prototype._anchor = null;
/** @private @type {null} */
com.inq.ui.IFrame.prototype._img = null;
/** @private @type {boolean} */
com.inq.ui.IFrame.prototype._useHandCursor = null;
/** @type {null} */
com.inq.ui.IFrame.prototype.label = null;
/** @type {null} */
com.inq.ui.IFrame.prototype.useHandCursor = null;
/** @type {com.inq.ui.IFrame} */
com.inq.ui.IFrame.prototype.__class__ = com.inq.ui.IFrame;
